import { useAuth } from '../contexts/Auth'
import { useCookieUser } from './cookieUser'

export const useIsAuthenticated = () => {
	const { currentUser } = useAuth() as any
	const { userIDCookie } = useCookieUser()
	return !!userIDCookie || !!currentUser
}
